import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api';
import { IRuleValidationResult } from '@cbridge-packages/rule';
import { IAdjustmentRule } from './adjustmentRule.interface';

export namespace AdjustmentRuleAction {
  const actionCreator = actionCreatorFactory('AdjustmentRule');

  export const reload = actionCreator('RELOAD');
  export const loadList = actionCreator.async<void, IAdjustmentRule[], IApiErrorParams>('LOAD_LIST');
  export const update = actionCreator.async<IAdjustmentRule[], IRuleValidationResult[], IApiErrorParams>('UPDATE');
  export const validate = actionCreator.async<IAdjustmentRule[], IRuleValidationResult[], IApiErrorParams>('VALIDATE');
  export const exportFile = actionCreator.async<void, void, IApiErrorParams>('EXPORT_FILE');

  export const destroy = actionCreator('DESTROY');
}
